import React from 'react';
import MeetingType, {MEETING_TYPES} from 'records/MeetingType';
import './MeetingTypeStep.styl';
import MeetingTypeSelector from 'components/coaching/MeetingTypeSelector';
import pick from 'lodash/pick';
import {validate} from 'records/CoachingPlan';

export default class MeetingTypeStep extends React.PureComponent {
  static title = 'Meeting Type';

  componentDidMount() {
    const {onChange, model: coachingPlan, completedSteps, step, editMode} = this.props;

    const coachName =
      coachingPlan.coach && coachingPlan.coach.info && coachingPlan.coach.info.getFullName();

    if (!coachName) return;

    // If we're in edit mode don't overwrite our meetingType
    if (editMode) return;

    // if we already set the meeting type, don't preload it again!
    if (!completedSteps.has(step)) {
      onChange(
        coachingPlan.set(
          'defaultMeetingType',
          new MeetingType({
            meetingType: 'PhysicalLocation',
            locationDetail: `${coachName}'s desk`,
          })
        )
      );
    }
  }

  static validate(plan) {
    return pick(validate(plan).meetingType, Object.values(MEETING_TYPES));
  }

  render() {
    const {model: coachingPlan, onChange, showErrors} = this.props;
    const {defaultMeetingType} = coachingPlan;
    const errors = MeetingTypeStep.validate(coachingPlan);

    return (
      <div className="coaching-step coaching-plan-wizard-meeting-type">
        <p>How will you meet?</p>
        <MeetingTypeSelector
          meetingType={defaultMeetingType}
          onChange={meetingType => onChange(coachingPlan.set('defaultMeetingType', meetingType))}
          showErrors={showErrors}
          errors={errors}
          showLocationLabels
        />
      </div>
    );
  }
}
